
<template>

  <span>
    <router-view name="nivel1"/>

    <sheetfooter />

  </span>

</template>

<script>

import sheetfooter from "@/components/core/sheetFooter";

export default {
  components: {sheetfooter},
  data () {
    return {
      //dialogColor: this.$vuetify.theme.themes.light.success,
    }
  },
  created() {
    //console.log(process.env.ROOT_API)
  }
}

</script>

<style>

  
  .dg-btn--cancel {
      color: #fefefe;
      background-color: #26a69a;
  }

  .dg-btn--ok {
    color: #26a69a !important;
    background-color: #fefefe;
    border-color: #26a69a !important;
  }

  /*.dg-btn-loader .dg-circle {
    //background-color: #43a047;
  } */



</style>



// WEBPACK FOOTER //
// src/App.vue